import { FragmentDefiner } from "../../../../../GlobalHooks/useReadFragment";

import { PropComponentMode } from "../../../PropertyInterfaces";
import { gql } from "@apollo/client/core";
import { useMutation, useLazyQuery } from "@apollo/client";
import { ButtonsLeadsSource, ModalState } from "../../TextForm/type";
import { Listing } from "shared-components";
import { useContext, useEffect } from "react";
import { REGISTER_MUTATION, USER_EXISTS_QUERY, UPDATE_USER_MUTATION } from "shared-components/Components/User/User.querys";
import { useUser } from "shared-components/Components/User/User.hook";
import cookie from "js-cookie";
import { getBaseDomain as loginBasePath } from "@Utils/Functions";
import { FormCallToActions } from "shared-components/Contexts/ContactModal/context";
import { ConfigStateContext } from "shared-components/Contexts/Configurations/context";
import { requiresContactData } from "src/utils/Functions";

const REQUEST_PHONE_MUTATION = gql`
	mutation request_phone_mutation(
		$property_id: Int!
		$type: PropEntityType
		$email: String
		$name: String
		$phone: String
	) {
		requestPhoneAgent(
			property_id: $property_id
			isWpp: false
			type: $type
			email: $email
			name: $name
			phone: $phone
		) {
			name
			phone
		}
	}
`;

export interface OwnerPhoneInterface {
	id?: number | string;
	listing?: Listing;
	type?: "callButton" | "viewPhone";
	disabled?: boolean;
	property_info?: any;
	color?: string;
	seller?: boolean;
	text?: string;
	queryRouter?: string;
	icon?: boolean;
	forceState?: ModalState;
	owner?: any;
	isProject?: boolean;
	data?: any;
	hasAcceptedTerms?: boolean;
	onTermsError?: (e) => void;
	onBeforeAction?: (e, cta: "phone") => boolean;
	callback?: ({ ctaButtons } : { ctaButtons: FormCallToActions }) => void;
	handleCloseContactModal?: () => void;
	source?: ButtonsLeadsSource,
	shouldAskForData?: boolean
}

export const FRAGMENT_MASKED_PHONE = new FragmentDefiner(
	"Property",
	`
	title
	seller {
		id
		name
		masked_phone
	}
    owner {
        id
        name
        masked_phone
    }
    operation_type {
    	id
    	name
    }
`
);

export const usePhoneButton = ({
	property_id,
	isProject,
	seller = false,
	email = null,
	phone = null,
	name = null,
}) => {
	const { country_code } = useContext(ConfigStateContext);
	const [mutation, { loading, data: mutationData, called }] = useMutation(
		REQUEST_PHONE_MUTATION,
		{
			onError: error => { },
		}
	);

	const [
		registerMutation,
		{ loading: registerLoading, data: dataRegisterMutation },
	] = useMutation(REGISTER_MUTATION);
	const [updateUserMutation, { loading: updateLoading }] = useMutation(UPDATE_USER_MUTATION);
	const updateUser = ({ name, phone }) => {
		return updateUserMutation({ variables: { name, phone } });
	};
	const { user,isLoggedIn } = useUser();
	const [
		userExistsQuery,
		{ loading: userExistsLoading, data: dataUserExist, error },
	] = useLazyQuery(USER_EXISTS_QUERY, {
		fetchPolicy: "network-only",
		onError: error => {
			if (error.message.includes("no existe")) {
				registerMutation({
					variables: {
						email: email,
						name: name,
					},
				})
					.then(({ data }) => {
						updateUser({ name: name, phone: phone }).then(() => {
							user.refetch();
						});
					})
					.catch(error => {
						console.error(error);
					});
			}
		},
	});

	const refreshAuth = data => {
		cookie.set("frontend_token", data.access_token, {
			expires: 365,
			domain: loginBasePath(),
			path: "/",
		});
		localStorage.setItem("user_md5", data.user_md5);
		user.refetch();
	};

	useEffect(() => {
		if (dataRegisterMutation) {
			refreshAuth(dataRegisterMutation.registerIndividual);
		}
	}, [dataRegisterMutation]);

	const askDataBeforeContact = requiresContactData(country_code);
	//nota: como el telefono se guarda en un state, no en cache de apolo. cada ver teléfono va a hacer la mutation por separado
	const viewPhone = async () => {
		if (askDataBeforeContact && (!email || !phone)) {
			return { error: "Email y Telefono no pueden ser vacíos." };
		}


		const currentUser = user?.data?.me;
		const hasChanges = currentUser && (currentUser?.name !== name || currentUser?.phone !== phone);

		if (askDataBeforeContact && isLoggedIn && user?.data?.me?.role == 'PRIVATE' && hasChanges) {
			updateUser({ name: name, phone: phone }).then(() => {
				user.refetch();
			});
		}


		return await mutation({
			variables: {
				property_id,
				type: isProject ? "PROJECT" : "PROPERTY",
				email,
				name,
				phone,
			},
		});
	};

	const filteredPhones = new Set(
		mutationData?.requestPhoneAgent?.map(item => item.phone).filter(phone => phone)
	);
	const phones = Array.from(filteredPhones).join(";");

	return {
		viewPhone,
		phone: phones,
		loading,
		userExistsQuery
	};
};
